import { useCallback, useMemo, useState } from 'react'

import type { CharacterCodeType } from 'components/common/CharacterCodeSelect/CharacterCodeSelect'

export type LoadFilePropsWithEncoding = { content: string; fileName: string }
export type LoadFilePropsWithoutEncoding = { content: ArrayBuffer; fileName: string }

export const useImportCsv = () => {
  const [file, setFile] = useState<File | null>(null)
  const [modalErrorMessage, setModalErrorMessage] = useState<string | undefined>(undefined)

  const importDisabled = useMemo(() => !(file && /\.csv$/i.test(file.name)), [file])

  const importCsvFileWithEncoding = useCallback(
    (onFileLoad: (data: LoadFilePropsWithEncoding) => void, encoding: CharacterCodeType) => {
      if (!file) {
        return
      }
      const reader = new FileReader()
      const fileLoad = () => {
        const content = reader.result
        if (!content) {
          setModalErrorMessage('ファイルが空です。')
          return
        }
        onFileLoad({
          content: content.toString(),
          fileName: file.name,
        })
      }

      reader.addEventListener('load', fileLoad)
      reader.addEventListener('error', () => setModalErrorMessage('ファイルの読み込みに失敗しました。'))
      reader.readAsText(file, encoding)
    },
    [file]
  )

  const importCsvFileWithOutEncoding = useCallback(
    (onFileLoad: (data: LoadFilePropsWithoutEncoding) => void) => {
      if (!file) {
        return
      }
      const reader = new FileReader()
      const fileLoad = () => {
        const content = reader.result
        if (content instanceof ArrayBuffer) {
          onFileLoad({
            content: content,
            fileName: file.name,
          })
          return
        }
        setModalErrorMessage('ファイルが空です。')
      }

      reader.addEventListener('load', fileLoad)
      reader.addEventListener('error', () => setModalErrorMessage('ファイルの読み込みに失敗しました。'))
      reader.readAsArrayBuffer(file)
    },
    [file]
  )

  return {
    importDisabled,
    setFile,
    importCsvFileWithEncoding,
    importCsvFileWithOutEncoding,
    setModalErrorMessage,
    modalErrorMessage,
  }
}
